'use strict';

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _asyncGeneratorDelegate = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var isIpfs = require('is-ipfs');

var CID = require('cids');

var _require = require('ipld-dag-pb'),
    DAGNode = _require.DAGNode;

var _require2 = require('../../utils'),
    normalizeCidPath = _require2.normalizeCidPath;

var _require3 = require('interface-datastore'),
    Errors = _require3.Errors;

var ERR_NOT_FOUND = Errors.notFoundError().code;

var _require4 = require('../../utils'),
    withTimeoutOption = _require4.withTimeoutOption;

var Format = {
  default: '<dst>',
  edges: '<src> -> <dst>'
};

module.exports = function (_ref) {
  var ipld = _ref.ipld,
      resolve = _ref.resolve,
      preload = _ref.preload;
  return withTimeoutOption( /*#__PURE__*/function () {
    var _refs = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ipfsPath, options) {
      var rawPaths, paths, _iterator2, _step2, path;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // eslint-disable-line require-await
              options = options || {};

              if (!(options.maxDepth === 0)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              if (!(options.edges && options.format && options.format !== Format.default)) {
                _context.next = 5;
                break;
              }

              throw new Error('Cannot set edges to true and also specify format');

            case 5:
              options.format = options.edges ? Format.edges : options.format || Format.default;

              if (typeof options.maxDepth !== 'number') {
                options.maxDepth = options.recursive ? Infinity : 1;
              }

              rawPaths = Array.isArray(ipfsPath) ? ipfsPath : [ipfsPath];
              paths = rawPaths.map(function (p) {
                return getFullPath(preload, p, options);
              });
              _iterator2 = _createForOfIteratorHelper(paths);
              _context.prev = 10;

              _iterator2.s();

            case 12:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 17;
                break;
              }

              path = _step2.value;
              return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(refsStream(resolve, ipld, path, options)), _awaitAsyncGenerator), "t0", 15);

            case 15:
              _context.next = 12;
              break;

            case 17:
              _context.next = 22;
              break;

            case 19:
              _context.prev = 19;
              _context.t1 = _context["catch"](10);

              _iterator2.e(_context.t1);

            case 22:
              _context.prev = 22;

              _iterator2.f();

              return _context.finish(22);

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[10, 19, 22, 25]]);
    }));

    function refs(_x, _x2) {
      return _refs.apply(this, arguments);
    }

    return refs;
  }());
};

module.exports.Format = Format;

function getFullPath(preload, ipfsPath, options) {
  // normalizeCidPath() strips /ipfs/ off the front of the path so the CID will
  // be at the front of the path
  var path = normalizeCidPath(ipfsPath);
  var pathComponents = path.split('/');
  var cid = pathComponents[0];

  if (!isIpfs.cid(cid)) {
    throw new Error("Error resolving path '".concat(path, "': '").concat(cid, "' is not a valid CID"));
  }

  if (options.preload !== false) {
    preload(cid);
  }

  return '/ipfs/' + path;
} // Get a stream of refs at the given path


function refsStream(_x3, _x4, _x5, _x6) {
  return _refsStream.apply(this, arguments);
} // Get formatted link


function _refsStream() {
  _refsStream = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve, ipld, path, options) {
    var resPath, parts, cid, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, obj;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _awaitAsyncGenerator(resolve(path));

          case 2:
            resPath = _context2.sent;
            // path is /ipfs/<cid>
            parts = resPath.split('/');
            cid = parts[2]; // Traverse the DAG, converting it into a stream

            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context2.prev = 7;
            _iterator = _asyncIterator(objectStream(ipld, cid, options.maxDepth, options.unique));

          case 9:
            _context2.next = 11;
            return _awaitAsyncGenerator(_iterator.next());

          case 11:
            _step = _context2.sent;
            _iteratorNormalCompletion = _step.done;
            _context2.next = 15;
            return _awaitAsyncGenerator(_step.value);

          case 15:
            _value = _context2.sent;

            if (_iteratorNormalCompletion) {
              _context2.next = 27;
              break;
            }

            obj = _value;

            if (obj.parent) {
              _context2.next = 20;
              break;
            }

            return _context2.abrupt("continue", 24);

          case 20:
            if (!obj.isDuplicate) {
              _context2.next = 22;
              break;
            }

            return _context2.abrupt("continue", 24);

          case 22:
            _context2.next = 24;
            return {
              ref: formatLink(obj.parent.cid, obj.node.cid, obj.node.name, options.format)
            };

          case 24:
            _iteratorNormalCompletion = true;
            _context2.next = 9;
            break;

          case 27:
            _context2.next = 33;
            break;

          case 29:
            _context2.prev = 29;
            _context2.t0 = _context2["catch"](7);
            _didIteratorError = true;
            _iteratorError = _context2.t0;

          case 33:
            _context2.prev = 33;
            _context2.prev = 34;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context2.next = 38;
              break;
            }

            _context2.next = 38;
            return _awaitAsyncGenerator(_iterator.return());

          case 38:
            _context2.prev = 38;

            if (!_didIteratorError) {
              _context2.next = 41;
              break;
            }

            throw _iteratorError;

          case 41:
            return _context2.finish(38);

          case 42:
            return _context2.finish(33);

          case 43:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[7, 29, 33, 43], [34,, 38, 42]]);
  }));
  return _refsStream.apply(this, arguments);
}

function formatLink(srcCid, dstCid, linkName, format) {
  var out = format.replace(/<src>/g, srcCid.toString());
  out = out.replace(/<dst>/g, dstCid.toString());
  out = out.replace(/<linkname>/g, linkName);
  return out;
} // Do a depth first search of the DAG, starting from the given root cid


function objectStream(_x7, _x8, _x9, _x10) {
  return _objectStream.apply(this, arguments);
} // Fetch a node from IPLD then get all its links


function _objectStream() {
  _objectStream = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(ipld, rootCid, maxDepth, uniqueOnly) {
    var seen, traverseLevel, _traverseLevel;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _traverseLevel = function _traverseLevel3() {
              _traverseLevel = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(parent, depth) {
                var nextLevelDepth, _iterator3, _step3, link;

                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        nextLevelDepth = depth + 1; // Check the depth

                        if (!(nextLevelDepth > maxDepth)) {
                          _context3.next = 3;
                          break;
                        }

                        return _context3.abrupt("return");

                      case 3:
                        _context3.prev = 3;
                        _context3.t0 = _createForOfIteratorHelper;
                        _context3.next = 7;
                        return _awaitAsyncGenerator(getLinks(ipld, parent.cid));

                      case 7:
                        _context3.t1 = _context3.sent;
                        _iterator3 = (0, _context3.t0)(_context3.t1);
                        _context3.prev = 9;

                        _iterator3.s();

                      case 11:
                        if ((_step3 = _iterator3.n()).done) {
                          _context3.next = 19;
                          break;
                        }

                        link = _step3.value;
                        _context3.next = 15;
                        return {
                          parent: parent,
                          node: link,
                          isDuplicate: uniqueOnly && seen.has(link.cid.toString())
                        };

                      case 15:
                        if (uniqueOnly) {
                          seen.add(link.cid.toString());
                        }

                        return _context3.delegateYield(_asyncGeneratorDelegate(_asyncIterator(traverseLevel(link, nextLevelDepth)), _awaitAsyncGenerator), "t2", 17);

                      case 17:
                        _context3.next = 11;
                        break;

                      case 19:
                        _context3.next = 24;
                        break;

                      case 21:
                        _context3.prev = 21;
                        _context3.t3 = _context3["catch"](9);

                        _iterator3.e(_context3.t3);

                      case 24:
                        _context3.prev = 24;

                        _iterator3.f();

                        return _context3.finish(24);

                      case 27:
                        _context3.next = 33;
                        break;

                      case 29:
                        _context3.prev = 29;
                        _context3.t4 = _context3["catch"](3);

                        if (_context3.t4.code === ERR_NOT_FOUND) {
                          _context3.t4.message = "Could not find object with CID: ".concat(parent.cid);
                        }

                        throw _context3.t4;

                      case 33:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, null, [[3, 29], [9, 21, 24, 27]]);
              }));
              return _traverseLevel.apply(this, arguments);
            };

            traverseLevel = function _traverseLevel2(_x11, _x12) {
              return _traverseLevel.apply(this, arguments);
            };

            // eslint-disable-line require-await
            seen = new Set();
            return _context4.delegateYield(_asyncGeneratorDelegate(_asyncIterator(traverseLevel({
              cid: rootCid
            }, 0)), _awaitAsyncGenerator), "t0", 4);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _objectStream.apply(this, arguments);
}

function getLinks(_x13, _x14) {
  return _getLinks.apply(this, arguments);
} // Recursively search the node for CIDs


function _getLinks() {
  _getLinks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(ipld, cid) {
    var node;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return ipld.get(new CID(cid));

          case 2:
            node = _context5.sent;

            if (!DAGNode.isDAGNode(node)) {
              _context5.next = 5;
              break;
            }

            return _context5.abrupt("return", node.Links.map(function (_ref2) {
              var Name = _ref2.Name,
                  Hash = _ref2.Hash;
              return {
                name: Name,
                cid: new CID(Hash)
              };
            }));

          case 5:
            return _context5.abrupt("return", getNodeLinks(node));

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getLinks.apply(this, arguments);
}

function getNodeLinks(node) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var links = [];

  for (var _i = 0, _Object$entries = Object.entries(node); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        name = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (CID.isCID(value)) {
      links.push({
        name: path + name,
        cid: value
      });
    } else if (typeof value === 'object') {
      links = links.concat(getNodeLinks(value, path + name + '/'));
    }
  }

  return links;
}